/*eslint-disable */
import React, { useState, useEffect } from "react";
import {
  withFormik,
  Form as Formiker,
  Field as Fieldmik,
  FieldArray,
  getIn,
} from "formik";
import * as yup from "yup";
import {
  Form as FormUi,
  Container,
  Button,
  Icon,
  Dropdown,
  Segment,
  Header,
  Divider
} from "semantic-ui-react";
import CreatAxios from "../axiosComponent/create";
import UpdateAxios from "../axiosComponent/update";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../redux/actions/alertAction";
import { connect } from "react-redux";
import SearchDropdown from "../createShipmentComponent/searchDropdown";
import ErrorMessage from "../createShipmentComponent/ErrorMessages";
import * as _ from "lodash";
import { translate } from "react-i18next";
import { AllRegex } from "../../utils/validation";
import MandatoryMark from "../common/mandatorymark";
import ReadAxios from "../axiosComponent/read";
import { isEmpty } from "lodash";

const InsertVendorShare = ({
  values,
  touched,
  errors,
  setFieldValue,
  handleSubmit,
  editData,
  t,
}) => {
  const setRouteList = (name, value) => {
    setFieldValue(name, JSON.stringify(stdObj));
  };

  const [vendors, setvendors] = useState([]);
  const [VehicleTypes, setVehicleTypes] = useState([]);

  useEffect(() => {
    getAllFetch();
  }, []);

  const getAllFetch = () => {
    ReadAxios({ url: "transporterMaster" })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setvendors([])
          : setStateVendors(res.data.resultSet);
      })
      .catch((err) => {
        setvendors([]);
      });
    ReadAxios({ url: `vehicleTypeMaster` })
      .then((res) => {
        isEmpty(res.data.resultSet)
          ? setVehicleTypes([])
          : setVehicleTypeState(res.data.resultSet);
      })
      .catch((err) => {
        setVehicleTypes([]);
      });
  };

  const setVehicleTypeState = (dataArray) => {
    let result = dataArray.map((item, index) => {
      return {
        raw: { ...item },
        text: item.vehicleType,
        key: index,
        value: item.vehicleTypeId,
      };
    });
    setVehicleTypes(result);
  };

  const setStateVendors = (dataArray) => {
    let result = dataArray.map((item, index) => {
      return {
        raw: { ...item },
        key: item.transporterCode,
        value: item.transporterMasterId,
        text: item.transporterName,
      };
    });
    setvendors(result);
  };

  const customerNo = localStorage.getItem('customerNumber')

  return (
    <React.Fragment>
      <Formiker>
        <Container fluid className="mt-2">
          <Segment>
            <div className="ui form tiny">
              <FormUi.Group inline>
                <FormUi.Field width={3}>
                  <label className="labelName">{t("create.source.title") || "Source"}</label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={
                    touched.start_checkpoint_name &&
                      errors.start_checkpoint_name
                      ? true
                      : false
                  }
                >
                  <SearchDropdown
                    setField={(name, data) => {
                      setFieldValue("start_checkpoint_name", data.title);
                      setFieldValue("start_checkpoint_id", data.key);
                    }}
                    masterRoute="getRouteCheckPoints"
                    masterRouteKey="checkPointMasterId"
                    masterRouteName="checkPointName"
                    fieldName="start_checkpoint_name"
                    placeholder={values.start_checkpoint_name}
                    defaultValue={`${values.start_checkpoint_name} ${values.start_checkpoint_id}`}
                  />
                  {touched.start_checkpoint_name &&
                    errors.start_checkpoint_name ? (
                      <div className="error-msg">{errors.start_checkpoint_name}</div>
                    ) : null}
                </FormUi.Field>
                <FormUi.Field width={2}></FormUi.Field>
                <FormUi.Field width={3}>
                  <label className="labelName">{t("create.destination.title") || "Destination"} </label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={
                    touched.end_checkpoint_name && errors.end_checkpoint_name
                      ? true
                      : false
                  }
                >
                  <SearchDropdown
                    setField={(name, data) => {
                      setFieldValue("end_checkpoint_name", data.title);
                      setFieldValue("end_checkpoint_id", data.key);
                    }}
                    masterRoute="getRouteCheckPoints"
                    masterRouteKey="checkPointMasterId"
                    masterRouteName="checkPointName"
                    fieldName="end_checkpoint_name"
                    placeholder={values.end_checkpoint_name}
                    defaultValue={`${values.end_checkpoint_name} ${values.end_checkpoint_id}`}
                  />
                  {touched.end_checkpoint_name && errors.end_checkpoint_name ? (
                    <div className="error-msg">{errors.end_checkpoint_name}</div>
                  ) : null}
                </FormUi.Field>
              </FormUi.Group>
              <FormUi.Group inline>
                <FormUi.Field width={3}>
                  <label className="labelName">{t("create.vehicle_type.title") ||  "Vehicle Type"}</label>
                </FormUi.Field>
                <FormUi.Field
                  width={4}
                  className="display-grid-center-imp"
                  error={
                    touched.vehicle_type_id && errors.vehicle_type_id
                      ? true
                      : false
                  }
                >
                  <Dropdown
                    clearable
                    style={{
                      width: "100%",
                      fontWeight: "normal",
                    }}
                    search
                    selection
                    placeholder={t("create.vehicle_type.placeholder") || "Select Vehicle Tyep"}
                    onChange={(name, data) =>
                      setFieldValue("vehicle_type_id", data.value)
                    }
                    options={VehicleTypes}
                    value={values.vehicle_type_id}
                  />
                  {touched.vehicle_type_id && errors.vehicle_type_id ? (
                    <div className="error-msg">{errors.vehicle_type_id}</div>
                  ) : null}
                </FormUi.Field>
              </FormUi.Group>
              {(
                <Segment piled>
                  <center className="mb-3">
                    <Header size="small"><b>{t(customerNo != 1158 ? "create.vendor_share" : "create.partner_share") ||  "Vendors Share"}</b></Header>
                  </center>
                  <Divider></Divider>
                  <Container>
                    <FieldArray
                      name="vendors"
                      render={(arrayHelpers) => (
                        <>
                          {values.vendors && values.vendors.length > 0
                            ? values.vendors.map((items, index) => (
                              <div key={index}>
                                <FormUi.Group>
                                  <FormUi.Field width={3}>
                                    <label className="labelName mt-2">
                                      {t(customerNo != 1158 ? "create.vendor.vendor_title" :"create.vendor.title") || "Vendor"}
                                    </label>
                                  </FormUi.Field>
                                  <FormUi.Field width={4}>
                                    <Dropdown
                                      clearable
                                      style={{
                                        width: "100%",
                                        fontWeight: "normal",
                                      }}
                                      search
                                      selection
                                      placeholder={t(customerNo != 1158 ? "create.vendor.vendor_placeholder" : "create.vendor.placeholder") || "Select Vendor"}
                                      onChange={(name, data) =>
                                        setFieldValue(
                                          `vendors[${index}].vendor_id`,
                                          data.value
                                        )
                                      }
                                      options={vendors}
                                      value={values.vendors[index].vendor_id}
                                    />
                                  </FormUi.Field>
                                  <FormUi.Field width={1} />
                                  <FormUi.Field width={3}>
                                    <label className="labelName mt-2">
                                      {t("create.allot_share.title") || "Allot Share"}
                                      <MandatoryMark />
                                    </label>
                                  </FormUi.Field>
                                  <FormUi.Field width={4}>
                                    <Fieldmik
                                      type="number"
                                      min={1}
                                      className="ui input"
                                      name={`vendors[${index}].vendor_share`}
                                      placeholder={t("create.allot_share.placeholder") || "Enter Allot Share"}
                                    />
                                  </FormUi.Field>
                                  <Button
                                    style={{ marginLeft: "10px" }}
                                    onClick={() => arrayHelpers.remove(index)}
                                    basic
                                    icon
                                    color="red"
                                    type="button"
                                  >
                                    <Icon name="trash" />{" "}
                                  </Button>
                                </FormUi.Group>
                              </div>
                            ))
                            : ""}
                          <Button
                            onClick={() =>
                              arrayHelpers.push({
                                vendor_id: "",
                                vendor_share: "",
                              })
                            }
                            basic
                            color="blue"
                            size="mini"
                            icon
                            type="button"
                          >
                            <Icon name="plus" />
                            {t(
                              "action_button.add_more"
                            ) || "Add More"}
                          </Button>
                        </>
                      )}
                    />
                  </Container>
                </Segment>
              )}
            </div>
          </Segment>
        </Container>
        <Container className="p-3" textAlign="center">
          <button
            className="w3-button w3-blue w3-hover-blue w3-round w3-small"
            type="button"
            onClick={() => handleSubmit()}
          >
            {t("action_button.submit") || "Submit"}
          </button>
        </Container>
      </Formiker>
    </React.Fragment>
  );
};

const FormikVendorShare = withFormik({
  validationSchema: yup.object({
    start_checkpoint_name: yup.string().required("Required"),
    end_checkpoint_name: yup.string().required("Required"),
    vehicle_type_id: yup.string().required("Required"),
    vendors: yup.array().of(
      yup.object().shape({
        vendor_id: yup.string().required("Required"),
        vendor_share: yup.number().required("Required"),
      })
    ),
  }),
  enableReinitialize: true,
  mapPropsToValues: (props) => {
    return {
      start_checkpoint_name: props.editData.source || "",
      start_checkpoint_id: props.editData.source_id || "",
      end_checkpoint_name: props.editData.destination || "",
      end_checkpoint_id: props.editData.destination_id || "",
      vehicle_type_id: props.editData.vehicle_type_id || "",
      vendors: props.editData.vendors || [
        { vendor_id: "", vendor_share: "" },
      ],
    };
  },
  async handleSubmit(values, { props, setSubmitting }) {
    console.log("from submited", values);
    setSubmitting(true)
    CreatAxios({
      completeURL: `${process.env.REACT_APP_MASTER_API_TWO}/vendor/share`,
      payload: { ...values },
    })
      .then((res) => {
        let alert = {
          type: "success",
          messageHeader: "Success",
          messageBody: res.data.message,
        };
        props.successAlertDispatcher(alert);
        props.onFormSubmit();
      })
      .catch((err) => {
        console.log(err);
        let alert = {
          type: "error",
          messageHeader: "Error",
          messageBody: "Unable to create new vendor share.",
        };
        props.errorAlertDispatcher(alert);
      });
  },
})(InsertVendorShare);

export default connect(null, { successAlertDispatcher, errorAlertDispatcher })(
  translate("vendor_share")(FormikVendorShare)
);
